import PropTypes from 'prop-types';
import React from 'react';
import { SimpleFlexbox } from '../../../flexbox/flexbox';
import styles from './layout_results_control.css';

/**
 * Layout component for results control when there is no results to display
 * @param {Object} props - The component's props
 * @param {Node} props.children - Children component(s)
 * @returns {Node} Results control layouts for no results page
 * @constructor
 */
const LayoutResultsControlNoResults = ({ children }) => {
    return (
        <SimpleFlexbox container>
            <SimpleFlexbox className={styles.row} contentBetween="sm">
                <SimpleFlexbox xs={0} sm={12} md={0} lg={0} xl={0} xxl={0} display="flex" contentEnd="sm">
                    {children}
                </SimpleFlexbox>
            </SimpleFlexbox>
        </SimpleFlexbox>
    );
};

LayoutResultsControlNoResults.propTypes = {
    children: PropTypes.node.isRequired
};

export { LayoutResultsControlNoResults };
